var React = require('react');

function Book (props) {
    return React.createElement("svg",props,[React.createElement("mask",{"fill":"#fff","key":0},React.createElement("rect",{"width":"64","height":"64","rx":"4"})),React.createElement("rect",{"width":"64","height":"64","rx":"4","fill":"#fff","stroke":"#1B68FF","strokeWidth":"12","mask":"url(#a)","key":1}),React.createElement("path",{"d":"M46.12 20c-3.04.17-9.1.8-12.83 3.07a.85.85 0 00-.4.73v20.06c0 .64.7 1.04 1.3.75 3.84-1.92 9.4-2.45 12.14-2.6.94-.04 1.67-.79 1.67-1.68V21.7c0-.98-.85-1.75-1.88-1.7zm-15.41 3.07c-3.74-2.27-9.79-2.9-12.83-3.07A1.74 1.74 0 0016 21.7v18.63c0 .9.73 1.64 1.67 1.69 2.75.14 8.3.67 12.15 2.59.6.3 1.3-.1 1.3-.74V23.79c0-.3-.15-.56-.41-.72z","fill":"#1B68FF","key":2})]);
}

Book.defaultProps = {"viewBox":"0 0 64 64","fill":"none"};

module.exports = Book;

Book.default = Book;
